
<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
       {{actionToBePerformed}}
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/customer-list">Back</router-link></li>        
        <li class="active">Add / Update Customer</li>
      </ol>
    </section>

    <section class="content">
        <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">
                <form @submit.prevent="addOrUpdateOrDeleteCustomer" action="#"  method="post">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Customer Configuration</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="name" class="required">Customer Name</label>
                            <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.name.required }" v-model="gRowObj.name" class="form-control" id="name" placeholder="Customer Name"  />
                            <span v-if="submitted && !$v.gRowObj.name.required" class="text-red pull-right">Please enter customer name.</span>
                          </div>

                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="name" class="required">Country</label>
                              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.country_id.required }" 
                              id="country_id" v-model="gRowObj.country_id">
                                <option value="">--Choose a Country--</option>
                                <option v-for="(data, index) in countryList" 
                                :selected="data.country_id === gRowObj.country_id" :key="index" :value="data.country_id">{{data.country_name}}</option>                    
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.country_id.required" class="text-red pull-right">Please choose an country.</span>
                            </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="name" class="required">Contract</label>
                              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.contract_status.required }" 
                              id="contract_status" v-model="gRowObj.contract_status">
                                <option value="">--Choose a Contract--</option>
                                <option v-for="data in customerContractList" 
                                :selected="data.value === gRowObj.contract_status" :key="data.value" :value="data.value">{{data.name}}</option>                    
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.contract_status.required" class="text-red pull-right">Please choose a contract.</span>
                            </div>
                        </div>
                      </div>

                      <!-- <div class="row ">
                          <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="type">Classification</label>                  
                              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.classification_id.required }" 
                              id="classification_id" v-model="gRowObj.classification_id" >
                                  <option v-for="(data, index) in classificationList" :key="data.id" :value="data.id"
                                  :selected="data.id === gRowObj.classification_id">{{data.type_name}}</option>                      
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.classification_id.required" class="text-red pull-right">Please choose an classification.</span>
                            </div>
                          </div>
                      </div> -->
                  </div>
                </div>

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">Preferred Default Conversation</h3>
                  </div>
                  <div class="panel-body">
                    <div class="row">
                      <div class="col-md-12 col-lg-12 col-xs-12">
                        <div class="form-group col-xs-6 col-sm-6 col-md-6">
                          <label for="type">Conversation</label>
                          <treeselect
                            placeholder="--Choose a conversation--" 
                            :multiple="false" 
                            :options="conversationList" 
                            v-model="gRowObj.conversation_id" /> 
                        </div>
                      </div>
                    </div>
                 </div>
                </div>    

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">Methods Removal</h3>
                  </div>
                  <div class="panel-body">

                  <div class="row">
                    <div class="col-md-12 col-lg-12 col-xs-12">
                        <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4">
                          <label class="required">Action</label>
                          <nv-select v-model="methodObj.methodAction" class="form-control" v-bind:class="{'form-group--error': frmAddRemoveMethodSubmitted && !$v.methodObj.methodAction.required}">
                            <option value="">--Select Action--</option>
                            <option v-for="(data, index) in methodActionList" :key="index" :value="data.id"
                              :selected="data.id === methodObj.methodAction">{{data.value}}</option>   
                          </nv-select>
                          <span v-if="frmAddRemoveMethodSubmitted && !$v.methodObj.methodAction.required" class="text-red pull-right">Please select method action.</span>
                        </div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <label class="required">Methods</label>
                            <nv-select multiple v-model="methodObj.choosenMethods" class="form-control"  v-bind:class="{'form-group--error': frmAddRemoveMethodSubmitted && !$v.methodObj.choosenMethods.required}">
                              <option v-for="(value, key) in servicesList" :key="key" :value="value.id">{{value.legacy_name + ' [' + value.altName + ']'}}</option>
                            </nv-select>
                            <span v-if="frmAddRemoveMethodSubmitted && !$v.methodObj.choosenMethods.required" class="text-red pull-right">Please select method.</span>
                          </div>
                        <div class="form-group col-xs-2 col-sm-2 col-md-2 padding-top-15px">
                          <i class="fa fa-plus-circle add-property" v-on:click="addOrRemoveMethod()" aria-hidden="true" style="margin-left: 20px;"></i>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12 col-lg-12 col-xs-12 padding-top-15px">
                      <div class="form-group col-xs-12 col-sm-12 col-md-12">
                        <table class="" style="width:100%" v-if="Object.keys(gRowObj.methods).length">
                          <thead class="thead-dark">
                          <tr>
                            <th>Action</th>
                            <th>Method</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                          <tr v-for="(item, index) in gRowObj.methods" :key="index">
                            <td style="width:20%">{{item.methodAction}}</td>
                            <td style="width:60%;">
                              <!-- {{item.choosenMethodsNames}} -->
                              <span v-for="(element, index) in item.choosenMethodsNames" :key="index">
                                 <button type="button" style="margin:2px;" class="btn btn-outline-secondary btn-sm">{{ element }}</button>
                              </span>
                            
                              </td>  
                            <td style="width:10%">
                              <i @click="editMethod(item, index)" class="fa fa-pencil" aria-hidden="true"></i>
                            </td>
                            <td style="width:10%">
                              <i @click="deleteMethod(item,index)" class="fa fa-times-circle" aria-hidden="true"></i>
                            </td>
                          </tr>
                      </table>
                      </div>
                    </div>
                    </div>

                  </div>
                </div>

                  <div class="row">
                  </div>
                  <div class="row">
                    <div class="action-button">
                      <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                      <input type="submit" class="btn btn-primary margin-left-20px" value="Submit">
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import { required } from 'vuelidate/lib/validators'
  import api from '../../../utils/api'
  import { customerContracts } from '../../../config/constants'
  // import _ from 'lodash'
  export default {
    name: 'modal',
    validations: {
      gRowObj: {
        country_id: { required },
        name: { required },
        contract_status: { required }
        // classification_id: { required },
      },
      methodObj: {
        methodAction: { required },
        choosenMethods: { required }
      }
      // isValidURL: 'The {attribute} shows how people see your Newsroom in your profile and must be filled in.'
    },
    data () {
      return {
        loading: false,
        isEdit: false,
        countryList: [],
        servicesList: [],
        methodActionList: [],
        classificationList: [],
        conversationList: [],
        validationErrors: [],
        languageList: [],
        customerContractList: customerContracts,
        // isValidUri: true,
        gRowObj: {
          id: null,
          name: '',
          country_id: '',
          classification_id: 'All',
          conversation_id: null,
          contract_status: '',
          methods: [],
          oldCustomerName: ''
        },
        methodObj: {
          methodAction: 'remove',
          choosenMethods: [],
          choosenMethodsNames: []
        },
        submitted: false,
        frmAddRemoveMethodSubmitted: false,
        actionToBePerformed: 'Add Customer'
      }
    },
    methods: {
      close () {
        // console.log('closing the modal')
        this.submitted = false
        this.$router.replace('customer-list')
      },
      async addOrUpdateOrDeleteCustomer (e) {
        console.log('inside addOrUpdateOrDeleteCustomer function')
        console.log(this.actionToBePerformed)
        console.log(this.gRowObj)
        this.submitted = true
        console.log(this.$v.gRowObj.$invalid)
        this.$v.gRowObj.$touch()
        if (this.$v.gRowObj.$invalid) {
          return
        }
        await this.addOrUpdateCustomers()
        this.submitted = false
      },
      async getConversationList () {
        return new Promise(resolve => {
          api.buildRequest('getSmsApps', 'POST').then(({ data }) => {
            this.conversationList = data.payload.map(conversation => { return { id: conversation.id, label: conversation.appName } })
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getCountryList () {
        return new Promise(resolve => {
          api.buildRequest('getCountryList', 'POST').then(({ data }) => {
            this.countryList = data.payload
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getServicesList () {
        return new Promise(resolve => {
          api.buildRequest('getMethodList', 'POST').then(({ data }) => {
            this.servicesList = data.payload
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getCustomerDetails (id) {
        const param = {
          id: id
        }
        return new Promise(resolve => {
          api.buildRequest('getCustomerDetails', 'POST', param).then(async ({ data }) => {
            if (data && data.payload && data.payload) {
              const objRes = data.payload
              // this.gRowObj = data.payload[0]
              // this.gRowObj.id
              console.log(this.gRowObj)
              this.gRowObj.id = objRes.id
              this.gRowObj.name = objRes.name
              this.gRowObj.oldCustomerName = objRes.name
              this.gRowObj.country_id = objRes.country_id || ''
              this.gRowObj.classification_id = objRes.classification_id || ''
              this.gRowObj.conversation_id = objRes.conversation_id || null
              this.gRowObj.classification_id = objRes.classification_id || 'All'
              this.gRowObj.contract_status = objRes.contract_status
              this.gRowObj.methods = objRes.methods || []
              console.log(this.gRowObj)
            }
            this.loading = false
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getClassification () {
        return new Promise(resolve => {
          this.classificationList = [
            {
              id: 'All',
              type_name: 'All'
            },
            {
              id: 'Public',
              type_name: 'Public Only'
            },
            {
              id: 'Private',
              type_name: 'Private Only'
            }
          ]
          this.methodActionList = [
            // {
            //   id: 'add',
            //   value: 'Add Methods'
            // },
            {
              id: 'remove',
              value: 'Remove Methods'
            }
          ]
          resolve(true)
        })
      },
      async addOrUpdateCustomers () {
        this.loading = true
        let param = {...this.gRowObj}
        param.conversation_id = param.conversation_id ? param.conversation_id : null
        if (this.gRowObj.id) {
          // -- call edit
          return new Promise(resolve => {
            api.buildRequest('updateCustomer', 'POST', param).then(({ data }) => {
              if (data.payload) {
                this.gRowObj.oldCustomerName = data.payload.name
              }
              this.$swal({
                type: 'success',
                text: 'Customer updated successfully'
              })
              resolve()
              this.loading = false
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        } else {
          // -- call add
          return new Promise(resolve => {
            api.buildRequest('addCustomer', 'POST', param).then(({ data }) => {
              if (data.payload) {
                this.isEdit = true
                this.gRowObj.id = data.payload.id
                this.gRowObj.oldCustomerName = data.payload.name
              }
              this.$swal({
                type: 'success',
                text: 'Customer added successfully'
              })
              resolve()
              this.loading = false
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        }
      },
      async addOrRemoveMethod () {
        console.log('inside add customer text function')
        console.log(this.methodObj)
        console.log(this.$v.methodObj.$invalid)
        this.frmAddRemoveMethodSubmitted = true
        this.$v.methodObj.$touch()
        if (this.$v.methodObj.$invalid) {
          return
        }
        // check is already exist
        const index = this.gRowObj.methods.findIndex(obj => obj.methodAction === this.methodObj.methodAction)
        if (index >= 0) {
          this.gRowObj.methods.splice(index, 1)
        }
        if (this.methodObj.choosenMethods) {
          this.methodObj.choosenMethods.forEach(each => {
            const filterMethods = this.servicesList.filter(obj => obj.id === each)
            if (filterMethods && Object.keys(filterMethods).length) {
              this.methodObj.choosenMethodsNames.push(filterMethods[0].legacy_name)
            }
          })
        }
        this.gRowObj.methods.push({
          methodAction: this.methodObj.methodAction,
          choosenMethods: this.methodObj.choosenMethods,
          choosenMethodsNames: this.methodObj.choosenMethodsNames
        })
        this.methodObj.methodAction = 'remove'
        this.methodObj.choosenMethods = []
        this.methodObj.choosenMethodsNames = []
        this.frmAddRemoveMethodSubmitted = false
      },
      async editMethod (item, index) {
        this.methodObj.methodAction = item.methodAction
        this.methodObj.choosenMethods = item.choosenMethods
      },
      async deleteMethod (item, index) {
        if (this.gRowObj.methods[index]) {
          this.gRowObj.methods.splice(index, 1)
        }
      }
    },
    async mounted () {
      this.gRowObj = {
        id: null,
        name: '',
        country_id: '',
        classification_id: 'All',
        conversation_id: null,
        contract_status: '',
        methods: []
      }
      this.methodObj = {
        methodAction: 'remove',
        choosenMethods: [],
        choosenMethodsNames: []
      }
      this.loading = true
      await this.getCountryList()
      await this.getServicesList()
      await this.getClassification()
      await this.getConversationList()
      this.actionToBePerformed = 'Add Customer'
      if (this.$route && this.$route.query && this.$route.query.customerId) {
        console.log('route query')
        console.log(this.$route.query.customerId)
        this.actionToBePerformed = 'Update Customer'
        this.isEdit = true
        await this.getCustomerDetails(this.$route.query.customerId)
      }
      this.loading = false
    }
  }
</script>
<style>
.margin-left-20px {
  margin-left: 20px;
}
.form-group .padding-15px {
  padding: 0 15px;
}
.padding-botton-15px {
  padding-bottom: 15px;
}
.padding-top-15px {
  padding-top: 15px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.body.modal-mask {
  position:fixed;
  height: 100vh;
  overflow-y: hidden;
}
.modal-header h3 {
  width: 100%;
  margin-top: 0;
  color: black;
}
.modal-body {
  overflow: auto;
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.disable {
  color: #b3b1b1;
}
.v-autocomplete {
  position:relative;
}
.v-autocomplete-input {
  padding:10px 15px;
  height:34px;
}
.v-autocomplete-list {
  width:calc(100% - 30px);
  border:1px solid #d2d6de;
  position:absolute;
  top:58px;
  z-index:111;
  list-style: none;
  padding: 0%;
  max-height: 110%;
  overflow: overlay;
}
.v-autocomplete-list-item {
  width:100%;
  border-bottom:1px solid #d2d6de;
  padding:6px 12px;
  font-size:14px;
  background-color:white;
  cursor:pointer;
}
.v-autocomplete-list-item:last-child {
  width:100%;
  border-bottom:none;
}
.v-autocomplete-list-item:hover {
  background-color: #d2d6de;
}
.msg-table thead, .msg-table tbody{
  display: inline-block;
}
.msg-table thead{
  width: calc(100% - 17px);
}
.msg-table tbody{
  max-height: calc(100vh - 300px);
  overflow: auto;
}
.msg-table th, .msg-table td {
  display: block;
  float: left;
}
.msg-table th:first-child, .msg-table td:first-child{
  width: calc(20% - 53px);
}
.msg-table th:nth-child(2), .msg-table td:nth-child(2), .msg-table th:nth-child(3), .msg-table td:nth-child(3){
  width: 40%;
}
.msg-table th:nth-child(4), .msg-table td:nth-child(4){
  width: 53px;
}
.alert-success{
   background-color:#d4edda !important; 
   border-color:#d4edda !important
}
.alert-danger{
   background-color:#f7d7da !important; 
   border-color:#f7d7da !important
}
.alert-warning{
   background-color:#fff3cd !important; 
   border-color:#fff3cd !important
}
.alert-info{
   background-color:#cce5ff !important; 
   border-color:#cce5ff !important
}


</style>



// WEBPACK FOOTER //
// addOrUpdateCustomer.vue?11880643